import { ShowComplaint } from "./show-complaints";

export default ShowComplaint;
